
// uses jquery barrating extension

// 2025-06 made functional

export function initStarWidgets() {
  // cannot arrow function here, jquery insists on owning 'this'
  $('.score-widget select').each( function() { initStarWidget(this) } );
}

function initStarWidget(elem) {
  let $e = $(elem);

  if (! $e.barrating) {
    return console.error("jquery barrating extension not installed");
  }
  return $e.barrating({
    initialRating: -1,
    theme: 'css-stars',
    showSelectedRating: true
  }).barrating('show');
}
